import { Controller } from 'react-hook-form';
import { TextKey } from '@mews-commander/enums';
import { FormInputField, getErrorComponent, LocalizedText } from '@mews/framework';
import { Banner, Divider, Container, Stack, StackItem } from '@optimus-web/core';
import { PrivilegesTable } from '../PrivilegesTable';
import { EditRoleFormValues } from '../schema';
import { usePortfolioSelectors } from '../utils';
import { EditRoleFormFieldNames } from './useEditRoleForm';

export const EditRoleForm = () => {
    const { isPortfolio, isInsidePortfolio } = usePortfolioSelectors();

    return (
        <Stack distribution="stretch" vertical spacing="200">
            {isInsidePortfolio && !isPortfolio ? (
                <Banner primaryText={<LocalizedText textKey={TextKey.RoleIsLocalEditBanner} />} variant="info" />
            ) : null}

            <FormInputField
                helper={<LocalizedText textKey={TextKey.RoleNameHint} />}
                label={<LocalizedText textKey={TextKey.RoleName} />}
                name={EditRoleFormFieldNames.Name}
                required
            />

            <Container padding={['200', '0']}>
                <Divider direction="horizontal" />
            </Container>

            <StackItem>
                <Controller<EditRoleFormValues, EditRoleFormFieldNames.Privileges>
                    name={EditRoleFormFieldNames.Privileges}
                    render={({ field, fieldState }) => (
                        <PrivilegesTable
                            rowSelection={field.value}
                            handleRowSelectionChange={field.onChange}
                            error={getErrorComponent(fieldState.error)}
                        />
                    )}
                />
            </StackItem>
        </Stack>
    );
};
